import { format, isThisYear } from 'date-fns';

export const getDateFormatter = (usTimeFormat: boolean) => {
  const datePattern = 'MMM dd';
  const fullDatePattern = 'MMM dd, Y';
  const hourPattern = usTimeFormat ? " 'at' h:mm a" : " 'at' H:mm";

  return (date: Date) => {
    const pattern = (isThisYear(date) ? datePattern : fullDatePattern) + hourPattern;

    return format(date, pattern);
  };
};
